export default {
  loadingWhatsappQRCodeRequest: false,
  whatsappQRCodeRequestFailed: false,
  whatsappQRCodeRequestSuccess: false,
  whatsappQRCode: null,
  whatsappQRCodeTimestamp: 0,

  loadingWhatsappCreateChannel: false,
  whatsappChannelCreateFailed: false,
  whatsappChannelCreateSuccess: false,
  whatsappChannelId: null,

  whatsappPollChannelId: null,
  whatsappPollInterval: null,
  whatsappPollSuccess: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/whatsapp/state.js